/*
 * file upload
 */
if ($('.delete-box').length) {
  $(document).on('change', 'input[type="file"]', function () {
    var input = $(this),
            label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.parent().parent().next(':text').val(label);
    var name = input.attr('name');
    var target = name.replace("upload_", "");
    var files = !!this.files ? this.files : [];
    if (!files.length || !window.FileReader)
      return; // no file selected, or no FileReader support
    if (/^image/.test(files[0].type)) { // only image file
      var reader = new FileReader(); // instance of the FileReader
      reader.readAsDataURL(files[0]); // read the local file
      reader.onloadend = function () { // set image data as background of div
        $('#preview_' + target).empty();
        $('#preview_' + target).append('<img src="' + this.result + '">');
        $('#' + target).val(label);
      }
    }
  });
  /*
   * file delete
   */
  $(document).on('click', '.delete-btn', function () {
    var id = $(this).attr('id');
    var target = id.replace("delete_", "");
    $('*[name=' + target + ']').val('');
    $('#readonly_' + target).val('');
    $('#preview_' + target).empty();
    $('#preview_' + target).append('<img src="/admin/img/no_photo.jpg">');
  })
}